/**
 * Hero splitting text + animations
 * @dependencies Splitting https://splitting.js.org
 * @dependencies GSAP https://greensock.com/gsap/
 */

import { gsap } from 'gsap';
import SplitText from '../vendors/gsap/SplitText';

gsap.registerPlugin(SplitText);

const textToSplit = document.querySelectorAll('.js-split-text');

if(textToSplit.length) {
  document.fonts.ready.then(function () {
    textToSplit.forEach((text) => {
      text.classList.add('is-ready');
    })
    let splitText = new SplitText(textToSplit, {type: 'lines', linesClass: 'line'});
    function kill(){
      splitText.revert();
    }

    function refreshLines() {
      kill();
      splitText.split({type: 'lines', linesClass: 'line'});
    }

    window.addEventListener('resize', debounce(refreshLines));

    // Get each line and wrap it up
    const lines = document.querySelectorAll('.line');
    const splitLines = new SplitText(lines, {type: 'lines', linesClass: 'inner-line'});

    // We need a timeline to stagger each lines has we animate the inner lines
    const tl = gsap.timeline();

    lines.forEach((line, index) => {
      if (index === 0) {
        tl.fromTo(line.querySelectorAll('.inner-line'), {
          y: '100%',
          autoAlpha: 0.5,
        },
        {
          y: 0,
          autoAlpha: 1,
          ease: "expo.out",
          duration: 0.6
        }, 'start');
      } else {
        const stagger = 0.1 * index;
        tl.fromTo(line.querySelectorAll('.inner-line'), {
          y: '100%',
          autoAlpha: 0.5,
        },
        {
          y: 0,
          autoAlpha: 1,
          ease: "expo.out",
          duration: 0.75
        }, `start+=${stagger}`);
      }
    })
  });
}

// Responsive handling of the headline
function debounce(func, timeout = 250){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
